<template>
  <v-app class="app-container">
    <base-sidebar :sidebarItems="sidebarItems" />
    <div class="app-wrapper pa-4">
      <base-header />
      <!-- Content -->
      <slot />
    </div>
    <!-- Notification -->
    <base-notification />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseHeader from '@/components/base/Header';
import BaseNotification from '@/components/base/Notification';
import BaseSidebar from '@/components/sidebar/Sidebar';
import sidebarItems from '@/components/sidebar/SidebarItems';

export default {
  name: 'DefaultLayout',
  components: {
    BaseHeader,
    BaseNotification,
    BaseSidebar
  },
  computed: {
    ...mapGetters({
      user: 'Auth/user',
      editing: 'general/editing'
    }),
    sidebarItems() {
      return sidebarItems?.[this.user?.roleId] ?? [];
    }
  },
  data: () => ({}),
  methods: {},
  created() {}
};
</script>

<style lang="scss">
body {
  background: #eee;
}

.app {
  &-container {
    position: relative;
    background: transparent !important;

    &:before {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      height: 280px;
      background: url('~@/assets/images/img-background-dc.png') repeat;
      z-index: -1;
    }
  }

  &-wrapper {
    font-family: Montserrat;
    font-size: 14px;
  }

  @include query-min-md() {
    &-wrapper {
      margin-left: 300px;
    }
  }
}
</style>
